/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `PRE_INCUBACAO` - Pré-incubação * `INCUBACAO` - Incubação * `GRADUACAO` - Graduação * `LEI_INFORMATICA` - Lei de Informática
 */
export enum Tipo6bcEnum {

    PRE_INCUBACAO = 'PRE_INCUBACAO',

    INCUBACAO = 'INCUBACAO',

    GRADUACAO = 'GRADUACAO',

    LEI_INFORMATICA = 'LEI_INFORMATICA'
}

